import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import coreActions from "../../state/reducers/core/coreActions.js";
import { resetErrors } from "../../state/reducers/api/apiActions.js";

class RedirectWithReset extends PureComponent {
  static propTypes = {
    watchersReady: PropTypes.bool.isRequired,
    resetWatchers: PropTypes.func.isRequired,
    resetErrors: PropTypes.func.isRequired
  };

  state = {
    ready: false
  };

  componentDidMount() {
    this.props.resetWatchers();
    this.props.resetErrors();

    this.setState({ ready: true });
  }

  // -- RENDER -- //

  render() {
    // watchers need to be up and running and this component needs to be mounted
    if (!this.props.watchersReady || !this.state.ready) return null;

    return <Redirect {...this.props} />;
  }
}

const mapStateToProps = state => ({
  watchersReady: state.watchers.isReady
});

const mapDispatchToProps = dispatch => ({
  resetWatchers: () => dispatch(coreActions.resetWatchers()),
  resetErrors: () => dispatch(resetErrors())
});

export default connect(mapStateToProps, mapDispatchToProps)(RedirectWithReset);
